'use strict';
import * as $j_app$002edata$002e$002dLine$002dItem from "./app.data.-Line-Item.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDiscount$0024 from "./app.data.data_point_types$package$-Discount$.js";
import * as $j_app$002epages$002eview$005fdocument$002e$002dView$002dInvoice$0024$002dRender$002dStyle$0024 from "./app.pages.view_document.-View-Invoice$-Render-Style$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps(items) {
  this.a8H = null;
  this.wE = false;
  this.wF = false;
  this.a8G = false;
  this.Mg = false;
  this.Mh = false;
  this.BN = null;
  this.a8H = items;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res = false;
  var it = items.r();
  while (((!res) && it.l())) {
    res = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_EmptyExts$package$().oH(it.k().yZ, $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDiscount$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$().AK(), $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDiscount$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$().iq());
  }
  this.wE = res;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$1 = false;
  var it$1 = items.r();
  while (((!res$1) && it$1.l())) {
    res$1 = (!it$1.k().uN.c());
  }
  this.wF = res$1;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$2 = false;
  var it$2 = items.r();
  while (((!res$2) && it$2.l())) {
    res$2 = (!it$2.k().z0.c());
  }
  this.a8G = res$2;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$3 = false;
  var it$3 = items.r();
  while (((!res$3) && it$3.l())) {
    res$3 = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasGrossWeight__Z(it$3.k());
  }
  this.Mg = res$3;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$4 = false;
  var it$4 = items.r();
  while (((!res$4) && it$4.l())) {
    res$4 = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasNetWeight__Z(it$4.k());
  }
  this.Mh = res$4;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
  var res$5 = false;
  var it$5 = items.r();
  while (((!res$5) && it$5.l())) {
    res$5 = $j_app$002edata$002e$002dLine$002dItem.$f_Lapp_data_LineItem__hasAnyWeight__Z(it$5.k());
  }
  this.BN = ((this.wF && this.wE) ? $j_app$002epages$002eview$005fdocument$002e$002dView$002dInvoice$0024$002dRender$002dStyle$0024.$s_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle$__VatAndDiscount__Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle() : (this.wF ? $j_app$002epages$002eview$005fdocument$002e$002dView$002dInvoice$0024$002dRender$002dStyle$0024.$s_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle$__VatOnly__Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle() : (this.wE ? $j_app$002epages$002eview$005fdocument$002e$002dView$002dInvoice$0024$002dRender$002dStyle$0024.$s_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle$__DiscountOnly__Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle() : $j_app$002epages$002eview$005fdocument$002e$002dView$002dInvoice$0024$002dRender$002dStyle$0024.$s_Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle$__Neither__Lapp_pages_view\uff3fdocument_ViewInvoice$RenderStyle())));
}
export { $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps as $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps };
$p = $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps;
/** @constructor */
function $h_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps() {
}
export { $h_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps as $h_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps };
$h_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps)) {
    var x = this.a8H;
    var x$2 = x$0.a8H;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "LineItemProps";
});
$p.e = (function(n) {
  matchResult4: {
    var $x_1;
    if ((n === 0)) {
      var $x_1 = this.a8H;
      break matchResult4;
    }
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector($x_1);
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "items";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kw)));
}
export { $isArrayOf_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps as $isArrayOf_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps };
var $d_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps, "app.pages.view_document.ViewInvoice$LineItemProps", ({
  kw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps as $d_Lapp_pages_view\uff3fdocument_ViewInvoice$LineItemProps };
//# sourceMappingURL=app.pages.view_document.-View-Invoice$-Line-Item-Props.js.map
